var CompanySize = {
	"Company size": "Tamaño de la empresa",
	"1-19 employees": "1-19 empleados",
	"20-99 employees": "20-99 empleados",
	"100-499 employees": "100-499 empleados",
	"500-999 employees": "500-999 empleados",
	"1,000-9,999 employees": "1000-9999 empleados",
	"10,000 employees or more": "10 000 o más empleados"
};

export { CompanySize as default };
